import React from "react";
import { Text, VStack } from "@chakra-ui/react";

const SnapTradeHeader: React.FC = () => {
  return (
    <VStack alignItems="flex-start" spacing={3}>
      <Text fontSize="lg" fontWeight={700}>Connect your brokerage accounts</Text>
    </VStack>
  );
};

export default SnapTradeHeader;


